import { useMemo } from 'react';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import AppBarStyled from './AppBarStyled';
import Profile from './HeaderContent/Profile';
import MobileSection from './HeaderContent/MobileSection';
import IconButton from 'components/@extended/IconButton';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

// assets
import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import MenuUnfoldOutlined from '@ant-design/icons/MenuUnfoldOutlined';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { NotificationAdd } from '@mui/icons-material';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  // header content
  const headerContent = useMemo(
    () => (
      <>
        <Box sx={{ width: '100%', ml: 1 }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto' }}>
          {!downLG && <Profile />}
          {downLG && <MobileSection />}
        </Box>
      </>
    ),
    [downLG]
  );

  // common header
  const mainHeader = (
    <Toolbar>
      {/* <IconButton
        aria-label="open drawer"
        onClick={() => handlerDrawerOpen(!drawerOpen)}
        edge="start"
        color="secondary"
        variant="medium"
        sx={(theme) => ({
          color: 'text.primary',
          fontSize: '18px',
          bgcolor: drawerOpen ? 'transparent' : 'grey.100',
          ml: { xs: 0, lg: 1 },
          '&:hover': {
            backgroundColor: 'transparent',
          },
        })}
      > */}
        {/* <MenuOpenIcon
          sx={{
            fontSize: 40,
            color: '#047857',
           
          }}
        />      </IconButton> */}
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      zIndex: 1200,
      width: { xs: '100%', lg: drawerOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${MINI_DRAWER_WIDTH}px)` }
    }
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled className='testing' open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar className='test1' {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}
